import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import Spinner from './components/common/Spinner'
import './index.css'
import './i18n'
import { PublicClientApplication, EventType } from "@azure/msal-browser"
import { msalConfig } from "./configs/msalAuthConfig.js"

/**
* MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
* For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
*/
const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.addEventCallback((event) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      event.payload.account
    ) {
      msalInstance.setActiveAccount(event.payload.account)
    }
})

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'navigate' && event.data.url) {
      console.log('Navigating to:', event.data.url)

      if (typeof window.router !== 'undefined' && typeof window.router.navigate === 'function') {
        window.router.navigate(event.data.url)
      } else {
        window.location.href = event.data.url
      }
    }
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <React.Suspense fallback={<div className="flex w-full h-screen justify-center items-center"><Spinner /></div>}>
      <App msalInstance={msalInstance} />
    </React.Suspense>
  </React.StrictMode>,
)
